import { render, staticRenderFns, recyclableRender, components } from "./ridingDetails.vue?vue&type=template&id=69af90bc&scoped=true&"
var renderjs
import script from "./ridingDetails.vue?vue&type=script&lang=js&"
export * from "./ridingDetails.vue?vue&type=script&lang=js&"
import style0 from "./ridingDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ridingDetails.vue?vue&type=style&index=1&id=69af90bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af90bc",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/ridingDetails/ridingDetails.vue"
export default component.exports